<template lang="pug">
  ods-module.loyalty-cuentas-table
    div(slot="header")
      span {{ this.$t('breadcrumb.accounts') }}
      div.text__item
        div.header-filter
          filter-table(
            layout="text"
            @inputSearchFilter="inputSearchFilter")
          ods-button(type="primary" size="medium" @click="goToCreate") {{ this.$t('loyalty.newAccount') }}
    div.text_item
      ods-table(
        v-loading="loadingTable"
        style='width: 100%'
        height="400px"
        :data='tableDataRendered'
        size="medium"
        )
        ods-table-column(prop='codcuent' :label="this.$t('loyalty.loyaltyAccount')" width='200')
          template(slot-scope="scope")
            div {{ scope.row.codcuent }}
        ods-table-column(prop='idclient' :label="this.$t('loyalty.IdNumber')" width='180')
          template(slot-scope="scope")
            ods-tag(type="info" size="medium") {{ scope.row.desctidc }}: {{ scope.row.idclient }}
        ods-table-column(prop='cliente' :label="this.$t('loyalty.client')")
          template(slot-scope="scope")
            div {{ scope.row.cliente }}
        ods-table-column(prop='indblqac' :label="this.$t('loyalty.accumulationBlockage')" align="center")
          template(slot-scope="scope")
            div {{ scope.row.indblqac }}
        ods-table-column(prop='indblqrd' :label="this.$t('loyalty.redeemableLock')" align="center")
          template(slot-scope="scope")
            div {{ scope.row.indblqrd }}
        ods-table-column(prop='cantpunt' :label="this.$t('loyalty.totalPoints')" align="right")
          template(slot-scope="scope")
            div {{ scope.row.cantpunt }}
        ods-table-column(prop='estado' :label="this.$t('loyalty.State')")
          template(slot-scope="scope")
            ods-tag(size="medium" :color="scope.row.estado === 'A' ? '#36B248' : scope.row.estado === 'B' ? '#FFA617' : '#DE2F2F'") {{ scope.row.estado === 'A' ? $t('loyalty.opened') : scope.row.estado === 'B' ? $t('loyalty.blocked') : scope.row.estado === 'C' ? $t('loyalty.closed') : '' }}
        ods-table-column(width='55')
          template(slot-scope='scope')
            ods-button(type="text" size="mini" icon='ods-icon-eye' @click="verDetalles(scope.row)" )
      div.footer
        paginator-table(
          :isNextPage="indMasDatos"
          :currentPage="currentPage"
          @buttonPrevAction="getPrevPage"
          @buttonNextAction="getNextPage")
      el-drawer(
        :visible.sync="createNewAccount"
        :before-close="closeCreateAccount"
        direction="rtl",
        size="55%"
        :wrapperClosable="false"
        :append-to-body="false")
        div(slot="title").loyalty-cuentas-table__nuevaCuenta-title
          div
            div
              h2.loyalty-cuentas-table__nuevaCuenta-title-text {{ this.$t('loyalty.newAccount') }}
            //div
              h2.loyalty-cuentas-table__required {{ this.$t('loyalty.requiredFields') }}
          div
            ods-select(v-model="selectProgram")
              ods-option(
                v-for="item in optionsMenuProgram"
                :key="item.value"
                :label="item.label"
                :value="item.value")
        ods-scrollbar(
          tag="div"
          :native="true"
          style="height: calc(100vh - 75px); padding: 0 0 32px 0;")
          ods-form.vendor-form(
            id="contentToScroll"
            label-position='top'
            :model='accountData'
            ref='createAccount'
            :rules="formrules"
            :show-message="showMessage")

            ods-row(:gutter='32')
              ods-col(:span='16')
                h2.mocuetitle {{ $t('loyalty.personalData') }}
              ods-col(:span='8' class='right')
                h2.loyalty-cuentas-table__required.mocueherror {{ $t('loyalty.requiredFields') }}

            ods-row(:gutter='32')
              ods-col(:span='8')
                ods-form-item(:label="this.$t('loyalty.Idtype')" prop="typeId" id="typeId")
                  ods-select(v-model="accountData.typeId" @change="changeTypeId")
                    ods-option(
                      v-for="item in optionsMenuID"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value")
                  div(class="ods-form-item__error" v-if="showTypeIdError") {{ this.$t('loyalty.requireField') }}
              ods-col(:span='8')
                ods-form-item(:label="this.$t('loyalty.dni')" prop="idNumber" id="idNumber")
                  ods-input(v-model="accountData.idNumber" :maxlength="20" :max="20" @input="changeInputIdNumber")
                  div(class="ods-form-item__error" v-if="showNumberIdError") {{ this.$t('loyalty.requireField') }}
              ods-col(:span='8')
                ods-form-item(:label="this.$t('loyalty.search')")
                  ods-button(type="text" icon="ods-icon-search" size="medium" :circle="false" :round="false" @click="checkIDClient(accountData)")

            ods-row(:gutter='32')
              ods-col(:span='8')
                ods-form-item(:label="$t('loyalty.name')" prop='name')
                  ods-input(:disabled="deactivateAccountForm" v-model='accountData.name' :maxlength='40' :max='40')
              ods-col(:span='8')
                ods-form-item(:label="$t('loyalty.firstName')" prop='firstName')
                  ods-input(:disabled="deactivateAccountForm" v-model='accountData.firstName' :maxlength='36' :max='36')
              ods-col(:span='8')
                ods-form-item(:label="$t('loyalty.lastName')" prop='lastName')
                  ods-input(:disabled="deactivateAccountForm" v-model='accountData.lastName' :maxlength='36' :max='36')

            ods-row(:gutter='32')
              ods-col(:span='8')
                ods-form-item(:label="$t('loyalty.gender')" prop='gender')
                  ods-radio-group(v-model='accountData.gender')
                    ods-radio(:disabled="deactivateAccountForm" label='V') {{ $t('loyalty.male') }}
                    ods-radio(:disabled="deactivateAccountForm" label='M') {{ $t('loyalty.female') }}
              ods-col(:span='8')
                ods-form-item(:label="this.$t('loyalty.maritalStatus')" prop="estadoCivil" id="estadoCivil")
                  ods-select(v-model="accountData.estadoCivil" :disabled="deactivateAccountForm")
                    ods-option(
                      v-for="item in estadoCivil"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value" class="wtf")
              ods-col(:span='8')
                ods-form-item(:label="this.$t('loyalty.birthDate')" prop="fecnac")
                  ods-date-picker(:disabled="deactivateAccountForm" format='dd/MM/yyyy' :picker-options="datepickerOptions" :clearable="false" v-model="accountData.fecnac" type="date" v-on:click.native="activeIndexPicker").loyalty-cuentas-table__form-picker

            ods-row(:gutter='32')
              ods-col(:span='16')
                h2.mocuetitle {{ this.$t('loyalty.adress') }}

            ods-row(:gutter='32')
              ods-col(:span='8')
                ods-form-item(:label="this.$t('loyalty.region')" prop="region" )
                  ods-input(:disabled="deactivateAccountForm"  v-model="accountData.region" :maxlength="3" :max="3")
              ods-col(:span='8')
                ods-form-item(:label="this.$t('loyalty.city')" prop="city")
                  ods-input(:disabled="deactivateAccountForm"  v-model="accountData.city" :maxlength="35" :max="35")
              ods-col(:span='8')
                ods-form-item(:label="this.$t('loyalty.postalCode')" prop="postalCode")
                  ods-input(:disabled="deactivateAccountForm"  v-model="accountData.postalCode" :maxlength="10" :max="10")
            ods-row(:gutter='32')
              ods-col(:span='8')
                ods-form-item(:label="this.$t('loyalty.email')" prop="email")
                  ods-input(:disabled="deactivateAccountForm"  v-model="accountData.email" :maxlength="50" :max="50")
              ods-col(:span='8')
                ods-form-item(:label="this.$t('loyalty.phone')" prop="phone")
                  ods-input(:disabled="deactivateAccountForm"  v-model="accountData.phone" :maxlength="10" :max="10")
          div.loyalty-cuentas-table__nuevaCuenta-footer
            ods-button(@click="closeCreateAccount" type="text") {{ this.$t('loyalty.cancel') }}
            ods-button(:disabled="deactivateAccountForm"  @click="createAccount") {{ this.$t('loyalty.create') }}

    el-drawer(
        :visible.sync="showDetails"
        direction="rtl",
        :before-close="closeDetails"
        :wrapperClosable="false"
        :append-to-body="false"
        :close-on-press-escape="false"
        size="55%"
        class="loyalty-cuentas-table__detalles")
        div(slot="title")
          ods-scrollbar()
            ods-tabs(v-model="activeTab").loyalty-cuentas-table__detalles-table
              ods-tab-pane(:label="$t('loyalty.personalData')" name="cliente")
                div(v-if="activeTab === 'cliente'")
                  detalle-cliente(:cuenta="rowSelected")
              ods-tab-pane(:label="$t('loyalty.pointsDetails')" name="detalles")
                div(v-if="activeTab === 'detalles'")
                  detalle-puntos(:cuenta="rowSelected")
              ods-tab-pane(:label="$t('loyalty.transactions')" name="movimientos")
                div(v-if="activeTab === 'movimientos'")
                  movimientos-table(:codCuent="idAccount" :cuenta="rowSelected")
</template>

<script>
import FilterTable from '@/components/shared/FilterTable'
import LoyaltyDropDown from '@/components/loyalty/LoyaltyDropDown'
import { mapActions, mapGetters } from 'vuex'
import DetallePuntos from '@/components/loyalty/Accounts/DetallePuntos'
import DetalleCliente from '@/components/loyalty/Accounts/DetalleCliente'
// import { Utils } from '@/utils/Utils.js'
import IdDropdown from '@/components/loyalty/Accounts/IdDropdown'
import MovimientosTable from '@/components/loyalty/Accounts/MovimientosTable'
import Paginator from '@/components/shared/Paginator'
import { Validator } from '@/utils/Validator.js'

export default {
  name: 'CuentasTable',
  props: {
    cambiarCuentas: {
      required: true
    }
  },
  data () {
    var validateText = (rule, value, callback) => {
      if (rule.field === 'name' || rule.field === 'firstName' || rule.field === 'lastName' || rule.field === 'city') {
        Validator.names(rule, value, callback)
      } else if (rule.field === 'idNumber') {
        Validator.docId(rule, value, callback)
      } else if (rule.field === 'fecnac') {
        Validator.birthDate(rule, value, callback)
      } else if (rule.field === 'estadoCivil') {
        Validator.maritalStatus(rule, value, callback)
      } else if (rule.field === 'gender') {
        Validator.gender(rule, value, callback)
      } else if (rule.field === 'region') {
        Validator.regionCode(rule, value, callback)
      } else if (rule.field === 'postalCode') {
        Validator.postalCode(rule, value, callback)
      } else if (rule.field === 'email') {
        Validator.email(rule, value, callback)
      } else if (rule.field === 'phone') {
        Validator.phone(rule, value, callback)
      }
    }

    return {
      rowSelected: null,
      loadingTable: false,
      tableDataRendered: null,
      tableData: null,
      currentPage: null,
      indMasDatos: null,
      paginationParams: null,
      createNewAccount: false,
      accountData: {},
      formrules: {
        typeId: [{ required: true, message: this.$t('loyalty.requireField'), trigger: 'blur' }],
        idNumber: [{ required: true, validator: validateText }],
        name: [{ required: true, validator: validateText }],
        firstName: [{ required: true, validator: validateText }],
        lastName: [{ required: false, validator: validateText }],
        gender: [{ required: true, validator: validateText }],
        postalCode: [{ required: true, validator: validateText }],
        email: [{ required: false, validator: validateText, trigger: 'blur' }],
        phone: [{ required: false, validator: validateText }],
        city: [{ required: false, validator: validateText }],
        region: [{ required: false, validator: validateText }],
        fecnac: [{ required: false, validator: validateText }],
        estadoCivil: [{ required: false, validator: validateText }]
      },
      showMessage: true,
      validateOnRuleChange: true,
      showDetails: false,
      activeTab: '',
      dataDetails: {},
      optionsMenuID: [],
      dropText: null,
      idAccount: '',
      deactivateAccountForm: true,
      selectProgram: '',
      optionsMenuProgram: [],
      formCloneData: {},
      showTypeIdError: false,
      showNumberIdError: false,
      notCheckID: false,
      tipcons: 'T',
      estadoCivil: [
        {
          label: 'Soltero/a',
          value: 1
        },
        {
          label: 'Casado/a',
          value: 2
        },
        {
          label: 'Viudo/a',
          value: 3
        },
        {
          label: 'Divorciado/a',
          value: 4
        },
        {
          label: 'Separado/a',
          value: 5
        },
        {
          label: 'Convivencia',
          value: 6
        }
      ],
      datepickerOptions: {
        disabledDate: function disabledDate (time) {
          // const tenYearFromNow = new Date()
          // tenYearFromNow.setFullYear(tenYearFromNow.getFullYear() - 10) // si necesitas añadir más antiguedad usa esta variable :)
          return time.getTime() > Date.now()
        }
      },
      isLoadingProgram: false
    }
  },
  components: {
    'menu-dropdown': LoyaltyDropDown,
    'filter-table': FilterTable,
    'detalle-puntos': DetallePuntos,
    'detalle-cliente': DetalleCliente,
    'id-dropdown': IdDropdown,
    'movimientos-table': MovimientosTable,
    'paginator-table': Paginator
  },
  computed: {
    ...mapGetters({
      loadingCounts: 'getLoadingCounts',
      appProgramTitle: 'getSelectedProgram',
      typeAccount: 'getTypeAccount'
    })
  },
  methods: {
    ...mapActions(['getAllAccounts', 'getAccountDetail', 'getIdDropdown', 'checkID', 'createNewAccountMethod']),
    async getData (params) {
      params.tipCons = this.typeAccount
      this.loadingTable = true
      const response = await this.getAllAccounts(params)
      if (response.registros && response.retorno !== 210) {
        this.tableData = Array.isArray(response.registros) ? response.registros : [response.registros]
        this.tableDataRendered = this.actualizarCampo(this.tableData)
        this.loadingTable = false
      } else {
        this.tableData = null
        this.tableDataRendered = this.tableData
        this.loadingTable = false
      }
      this.isLoadingProgram = false
      this.currentPage = response.pantPagina
      this.indMasDatos = response.indMasDatos
      this.paginationParams = {
        claveInicio: response.claveInicio,
        claveFin: response.claveFin
      }
    },
    changeTypeId () {
      this.showTypeIdError = false
      this.removeErrorCheckID()
    },
    formatDate (date) {
      var d = new Date(date)
      return new Date(d.getTime() - d.getTimezoneOffset() * 60 * 1000).toISOString().split('T')[0]
    },
    validatorIdClient (rule, value, callback) {
      if (typeof value !== 'undefined') {
        this.showNumberIdError = false
        this.removeErrorCheckID()
      }
      if (value === '') {
        callback(new Error('Campo obligatorio'))
      }
    },
    transforData (data) {
      for (const i in data) {
        if (data[i].estado === this.$t('loyalty.opened')) {
          data[i].estado = 'A'
        }
        if (data[i].estado === this.$t('loyalty.blocked')) {
          data[i].estado = 'B'
        }
        if (data[i].estado === this.$t('loyalty.closed')) {
          data[i].estado = 'C'
        }
      }
      return data
    },
    inputSearchFilter (text) {
      for (const i in this.tableData) {
        if (this.tableData[i].estado === 'A') {
          this.tableData[i].estado = this.$t('loyalty.opened')
        }
        if (this.tableData[i].estado === 'B') {
          this.tableData[i].estado = this.$t('loyalty.blocked')
        }
        if (this.tableData[i].estado === 'C') {
          this.tableData[i].estado = this.$t('loyalty.closed')
        }
      }
      this.tableDataRendered = this.transforData(this.tableData.filter(obj => Object.values(obj).some(val => val.toString().toLowerCase().indexOf(text.toLowerCase()) > -1)))
    },
    getPrevPage () {
      const params = {
        ...this.defaultParams,
        ...this.paginationParams,
        retroceder: true
      }
      this.getData(params)
    },

    getNextPage () {
      const params = {
        ...this.defaultParams,
        ...this.paginationParams,
        avanzar: true
      }
      this.getData(params)
    },
    async goToCreate () {
      const response = await this.getIdDropdown()
      this.optionsMenuID = this.convertDataID(response.registros)
      const getListProgram = JSON.parse(sessionStorage.getItem('listProgram'))
      const getProgram = sessionStorage.getItem('appProgram')
      this.selectProgram = getProgram
      this.optionsMenuProgram = getListProgram
      this.createNewAccount = true
    },
    createAccount () {
      let params = this.accountData
      this.$refs.createAccount.validate((valid) => {
        const validateFecnac = /Invalid Date/i
        if (validateFecnac.test(this.accountData.fecnac)) {
          this.accountData.fecnac = ''
        }
        if (valid) {
          params = Object.assign({}, params, {
            gender: this.accountData.gender,
            program: this.selectProgram,
            indexiste: this.idExist,
            typeId: this.accountData.typeId.replace(/\s+/g, ' ').trim(),
            fecnac: this.accountData.fecnac ? this.formatDate(this.accountData.fecnac) : ''
          })
          this.$store.dispatch('createNewAccountMethod', params)
            .then((res) => {
              if (res) {
                const checkIfException = /E7542636/i
                if (checkIfException.test(res.descRetorno)) {
                  var msg = res.descRetorno.substring(9, res.descRetorno.length).toLowerCase()
                  msg = msg.charAt(0).toUpperCase() + msg.slice(1) + '.'
                  this.$notify({
                    message: msg,
                    position: 'top-left',
                    type: 'error',
                    duration: 6000
                  })
                } else {
                  const elm = document.getElementById('contentToScroll')
                  elm.scrollIntoView({ block: 'start' })
                  this.$refs.createAccount.resetFields()
                  this.createNewAccount = false
                  this.deactivateAccountForm = true
                  this.$notify({
                    message: this.$t('loyalty.createAccount'),
                    position: 'top-left',
                    type: 'success',
                    duration: 6000
                  })
                }
              }
            })
        }
      })
    },
    async verDetalles (row) {
      this.rowSelected = row
      this.activeTab = 'cliente'
      this.showDetails = true
    },
    closeDetails () {
      console.log('closing details', this.paginationParams)
      this.rowSelected = null
      this.activeTab = ''
      this.showDetails = false
      if (this.paginationParams.claveInicio === 1) {
        this.getData({
          ...this.defaultParams,
          ...this.paginationParams
        })
      } else {
        this.paginationParams.claveInicio -= 20
        this.paginationParams.claveFin = this.paginationParams.claveInicio + 19
        this.getData({
          ...this.defaultParams,
          ...this.paginationParams,
          avanzar: true
        })
      }
    },
    actualizarCampo (data) {
      for (const i in data) {
        if (data[i].indblqac === 0) {
          data[i].indblqac = this.$t('loyalty.no')
        } else {
          data[i].indblqac = this.$t('loyalty.yes')
        }
        if (data[i].indblqrd === 0) {
          data[i].indblqrd = this.$t('loyalty.no')
        } else {
          data[i].indblqrd = this.$t('loyalty.yes')
        }
      }
      return data
    },
    convertDataID (data) {
      const options = []
      for (const i in data) {
        options.push({
          label: data[i].desctidc,
          value: data[i].tipidcli
        })
      }
      return options
    },
    addErrorCheckID () {
      const IdNumberDiv = document.querySelector('#idNumber')
      const typeIdDiv = document.querySelector('#typeId')
      if (typeof this.accountData.idNumber === 'undefined') {
        IdNumberDiv.classList.add('is-error')
        this.showNumberIdError = true
        this.notCheckID = true
      }
      if (typeof this.accountData.typeId === 'undefined' || this.accountData.typeId === '') {
        typeIdDiv.classList.add('is-error')
        this.showTypeIdError = true
        this.notCheckID = true
      }
    },
    removeErrorCheckID () {
      const IdNumberDiv = document.querySelector('#idNumber')
      const typeIdDiv = document.querySelector('#typeId')
      if (!this.showNumberIdError) {
        IdNumberDiv.classList.remove('is-error')
        this.showNumberIdError = false
      }
      if (!this.showTypeIdError) {
        typeIdDiv.classList.remove('is-error')
        this.showTypeIdError = false
      }
    },
    async checkIDClient (data) {
      const comprobe = /^[A-Za-z0-9]+$/
      this.notCheckID = false
      this.formCloneData = this.accountData
      if (!this.accountData.idNumber === '') {
        this.$refs.createAccount.clearValidate()
      }
      this.addErrorCheckID()
      this.accountData = {}
      this.accountData = Object.assign({}, this.accountData, {
        idNumber: this.formCloneData.idNumber,
        typeId: this.formCloneData.typeId
      })
      this.deactivateAccountForm = true
      const params = {
        idClient: data.idNumber,
        tipidcli: data.typeId
      }
      if (!this.notCheckID && comprobe.test(this.accountData.idNumber)) {
        const response = await this.checkID(params)
        if (response.registros) {
          if (response.registros.indexiste === 'N') {
            this.$refs.createAccount.clearValidate()
            this.$notify({
              message: this.$t('loyalty.userNotExist'),
              position: 'top-left',
              type: 'error',
              duration: 6000
            })
            this.idExist = response.registros.indexiste
            this.deactivateAccountForm = false
            // this.removeErrorCheckID()
          }
          if (response.registros.indexiste === 'S') {
            this.$refs.createAccount.clearValidate()
            this.accountData = Object.assign({}, this.accountData, {
              name: response.registros.nombre ? response.registros.nombre : '',
              firstName: response.registros.apellid1 ? response.registros.apellid1 : '',
              lastName: response.registros.apellid2 ? response.registros.apellid2 : '',
              gender: response.registros.sexo ? response.registros.sexo : '',
              region: response.registros.codregion ? response.registros.codregion : '',
              city: response.registros.poblacion ? response.registros.poblacion : '',
              postalCode: response.registros.codpostal ? response.registros.codpostal : '',
              email: response.registros.desclave1 ? response.registros.desclave1.replace(/\s+/g, ' ').trim() : '',
              phone: response.registros.desclave2 ? response.registros.desclave2.replace(/\s+/g, ' ').trim() : '',
              fecnac: response.registros.fecnac ? response.registros.fecnac : null,
              estadoCivil: response.registros.indestciv ? response.registros.indestciv : null
            })
            this.idExist = response.registros.indexiste
            this.deactivateAccountForm = false
            this.$refs.createAccount.validate()
            // this.removeErrorCheckID()
          }
        }
      }
    },
    closeCreateAccount () {
      const elm = document.getElementById('contentToScroll')
      elm.scrollIntoView({ block: 'start' })
      this.showNumberIdError = false
      this.showTypeIdError = false
      this.removeErrorCheckID()
      this.$refs.createAccount.clearValidate()
      this.$refs.createAccount.resetFields()
      this.accountData = {}
      this.createNewAccount = false
      this.deactivateAccountForm = true
    },
    changeInputIdNumber () {
      this.showNumberIdError = false
      this.removeErrorCheckID()
    },
    activeIndexPicker () {
      const picker = document.querySelector('.ods-date-picker')
      picker.style.zIndex = '9999'
    }
  },
  async mounted () {
    this.loadingTable = true
    this.activeTab = ''
    const params = {
      tipCons: ''
    }
    if (!this.loadingCounts) {
      this.getData(params)
    }
  },
  watch: {
    async appProgramTitle (data, oldData) {
      this.isLoadingProgram = true
      this.$store.commit('SET_TYPE_ACCOUNT', 'T')
      const params = {
        tipCons: this.typeAccount
      }
      this.tipcons = params.tipCons
    },
    async typeAccount (data, oldData) {
      if (!this.isLoadingProgram) {
        const params = {
          tipCons: data
        }
        await this.getData(params)
      }
    },
    loadingCounts (data, oldData) {
      const params = {
        tipCons: ''
      }
      if (this.loadingCounts) {
        this.getData(params)
      }
    },
    closeCreateAccount () {
      this.createNewAccount = false
      this.accountData = {}
    }
  }
}
</script>

<style lang="scss" scoped>
.loyalty-cuentas-table{
  .header-filter{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 10px;
}

&__drawer{
 /deep/ .el-drawer__open .el-drawer.rtl{
  width: auto;
}
}

&__form-column{
  display: flex;
  flex-wrap: wrap;
  column-gap: 30px;
  margin: 16px 0;
  > div {
    width: 40% !important;
  }

  .genderSelection{
    display: flex;
    flex-direction: column;
    /deep/ .ods-form-item__content {
      display: flex !important;
      height: 100%;
    }
  }
}

&__detalles-table{
  /deep/ .ods-tabs__item:focus.is-active.is-focus:not(:active) {
    box-shadow: inset 0 0 0 0 #fff !important;
    border-radius: 0 !important;
  }
}

  /deep/ .ods-form-item.is-required:not(.is-no-asterisk)>.ods-form-item__label:after{
      color: red;
  }

&__form-picker{
  .ods-picker-panel{
  z-index: 9999 !important;
}
}

&__modal-header{
  margin-top: 40px;
  margin-bottom: 40px;
  font-size: 16px;
}

&__title-label{
  font-size: 0.875rem;
  font-weight: 400;
  margin-top: 24px;
}

&__required{
  color: #DE2F2F
}
.notfound {
  margin-top: rem(28)
}

&__nuevaCuenta-title{
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
}

&__nuevaCuenta-title-text{
  font-size: 16px;
  color: #060E14;
  font-weight: 500;
}

&__nuevaCuenta-footer{
    display: flex;
    // height: 40%;
    padding: 24px 24px 24px 0;
    justify-content: flex-end;
    align-items: flex-end;
}

  /deep/ .ods-checkbox__inner{
    border-radius: 16px;
  }

&__checkID{
  height: 40px !important;
  max-height: 40px !important;
  margin-top: 10px;
}

&__filter{
  display: flex;
  justify-content: space-between;
  padding-bottom: 32px;
}

&__detalles{
  background-color: transparent !important;
  border: none !important;
  color: #2e6c99 !important;
  box-shadow: none !important;

 .detalles-grid{
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto;
    row-gap: 24px;
 }
  /deep/ .el-drawer__close-btn{
    height: 100%;
    display: flex;
    justify-content: center;
  }
}
  /deep/ &__closed:before {
    -webkit-border-radius: 1em;
    border-radius: 1em;
    background-color: #DE2F2F;
  }
}

.vendors-subheader {
  display: flex;
  justify-content: space-between;
  // align-items: baseline;
}

.form-grid {
  margin-top: rem(16);
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: auto;
  column-gap: 48px;
  row-gap: 22px;
}

.ods-form-item {
  line-height: 16px;
}

 /deep/ .el-drawer__header{
   margin-bottom: 8px;
   padding: 32px 24px 0 32px;
 }

 /deep/ .el-drawer__body{
   padding: 12px 32px 0 32px
 }

.mocuetitle {
  padding-top: 15px;
  font-size: 16px;
  color: #060E14;
  font-weight: 500;
  padding-bottom: 30px;
}

</style>
